// extracted by mini-css-extract-plugin
export default {"body":"scaled-text-body-r81TqR"};